module.exports = __webpack_public_path__ + "static/img/pic_1.234fb77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quiz/pic_1.png
// module id = X8ao
// module chunks = 37